import React, { useState, useEffect, useContext, useMemo } from "react";
import GridSoldOrOffer from "./GridSoldOrOffer";
import translations from "../../../utils/language/translations.json";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from 'react-router-dom';
const ViewSaleOffer = ({
  saleOffers,
  userId,
  preselected,
  preSelectedTransaction,
  asWho,
  liveCsrfToken,
  fetchSoldOrOffer,
}) => {
  const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language;
  const [transactions, setTransactions] = useState([]);
  const [selectedBuyerOption, setSelectedBuyerOption] = useState(null);
  const [selectedSellerOption, setSelectedSellerOption] = useState(null);
  //  const [selectedOption, setSelectedOption] = useState(preselected);
  const t = (key) => translations.ViewSaleOffer[key][currentLang];
  // Step 2: Create a function to handle option selection
  console.log("👤 userId", userId, typeof userId);
  console.log("📦 saleOffers", saleOffers);
 //http://localhost:3000/transactions/115?modal=marketplace&asWho=Seller&preselected=AwaitingPayment&transactionId=115
 //http://localhost:3000/marketplace/offers?preselected=Waiting&sellView=soldOrOffer
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
const preselectedParam = preselected ?? searchParams.get("preselected") ?? "Waiting";
const asWhoParam = asWho ?? searchParams.get("asWho"); // may be null
const initialOpenTxId = preSelectedTransaction ?? searchParams.get("transactionId") ?? 0;
  
  useEffect(() => {
    console.log("Updated saleOffers:", saleOffers);
  }, [saleOffers]);
  // const normalizeOptionValue = (value) => {
  //   console.log("normalizeOptionValue", value);
  //   switch (value) {
  //     case "AwaitingShipment":
  //       return "WaitingShipment"; // Match the label
  //     case "AwaitingPayment":
  //       return "WaitingPayment"; // Match the label
  //     default:
  //       return value; // Return unchanged if no mapping needed
  //   }
  // };
// Map backend/links → your actual menu values per role
const normalizeOptionValue = (value, role) => {
  const v = String(value || "").trim();

  // Shipment group
  if (v === "AwaitingShipment" || v === "WaitingShipment") {
    return role === "Buyer" ? "ComingYourWay" : "ShipNow";
  }
  if (v === "Shipped") {
    return role === "Buyer" ? "ComingYourWay" : "Shipped";
  }

  // Payment group
  if (v === "AwaitingPayment" || v === "WaitingPayment") {
    return role === "Buyer" ? "PayNow" : "WaitingPayment";
  }

  // Otherwise leave as-is (Waiting, Accepted, Rejected, Completed, Sent, Countered, etc.)
  return v;
};

// Choose which side (Buyer/Seller) to show, even if asWho is missing in URL,
// and normalize preselected to the menu value for that side.
useEffect(() => {
  if (!preselectedParam) return;

  // 1) If asWho is provided → use it
  let role = asWhoParam;

  // 2) Else infer from the tab name (Buyer-only tabs vs Seller-only tabs)
  if (!role) {
    const buyerOnly = ["PayNow", "ComingYourWay"];
    const sellerOnly = ["ShipNow", "WaitingPayment", "Shipped"];
    const v = String(preselectedParam);

    if (buyerOnly.includes(v)) role = "Buyer";
    else if (sellerOnly.includes(v)) role = "Seller";
  }

  // 3) Else infer from data (which side has something under that tab)
  if (!role && transactions.length > 0) {
    const buyerNorm = normalizeOptionValue(preselectedParam, "Buyer");
    const sellerNorm = normalizeOptionValue(preselectedParam, "Seller");
    const buyerCount = filterSaleOffers(buyerNorm, "buyer").length;
    const sellerCount = filterSaleOffers(sellerNorm, "seller").length;
    if (buyerCount > 0 || sellerCount > 0) {
      role = buyerCount >= sellerCount ? "Buyer" : "Seller";
    }
  }

  // Default to Seller if we still couldn't decide
  if (!role) role = "Seller";

  const normalized = normalizeOptionValue(preselectedParam, role);

  if (role === "Buyer") {
    setSelectedBuyerOption(normalized);
    setSelectedSellerOption(null);
    console.log("Deep-link → Buyer with", preselectedParam, "→", normalized);
  } else {
    setSelectedSellerOption(normalized);
    setSelectedBuyerOption(null);
    console.log("Deep-link → Seller with", preselectedParam, "→", normalized);
  }
}, [preselectedParam, asWhoParam, transactions, userId]);

  // useEffect(() => {
  //   if (asWho === "Buyer") {
  //     setSelectedBuyerOption(normalizeOptionValue(preselected));
  //     console.log(
  //       "as Buyer with",
  //       preselected,
  //       " ",
  //       normalizeOptionValue(preselected)
  //     );
  //   } else if (asWho === "Seller") {
  //     setSelectedSellerOption(normalizeOptionValue(preselected));
  //     console.log(
  //       "as Seller with",
  //       preselected,
  //       "normalizeOptionValue(preselected)",
  //       normalizeOptionValue(preselected)
  //     );
  //   }

  // }, [preselected, asWho,userId]);

  useEffect(() => {
    if (saleOffers.length > 0) {
      console.log("Updated saleOffers in ViewSaleOffer:", saleOffers);
      const groupedTransactions = Object.values(
        saleOffers.reduce((acc, object) => {
          const TransactionId = object.TransactionId;
          acc[TransactionId] = acc[TransactionId] || [];
          acc[TransactionId].push(object);
          return acc;
        }, {})
      );
      console.log("Updated transactions:", groupedTransactions);
      setTransactions(groupedTransactions);
    }
  }, [saleOffers]); // ✅ Updates transactions only when saleOffers changes

  const handleBuyerOptionChange = (option) => {
    setSelectedBuyerOption(option);
    setSelectedSellerOption(null); // Deselect seller menu when selecting buyer menu
  };

  const handleSellerOptionChange = (option) => {
    setSelectedSellerOption(option);
    setSelectedBuyerOption(null); // Deselect buyer menu when selecting seller menu
  };

  useEffect(() => {
    if (transactions.length > 0) {
      console.log("Transactions are ready for filtering:", transactions);
    }
  }, [transactions]);

  const filterSaleOffers = (status, role) => {
    let filteredOffers = transactions.filter((offer) => {
      if (role === "buyer") return offer[0].BuyerId === userId;
      if (role === "seller") return offer[0].SellerId === userId;
      return false;
    });
  
    
    return filteredOffers.filter((offer) => {
       console.log('offer[0]',offer[0])
      switch (status) {
        case "Waiting":
          return (offer[0].Status === "Waiting" ||(offer[0].Status === "Counter"&&offer[0].IsitACounterOffer===1&&(userId===offer[0].SellerId)));
        case "PayNow":
          return offer[0].Status === "WaitingPayment";
        case "WaitingShipment":
        case "ShipNow":
          return offer[0].Status === "WaitingShipment";
        case "ComingYourWay":
        case "Shipped":
          return offer[0].Status === "Shipped";
        case "WaitingPayment":
          return offer[0].Status === "WaitingPayment";
        case "Accepted":
          return (
            offer[0].Status === "Accepted" ||
            offer[0].Status === "WaitingPayment" ||
            offer[0].Status === "WaitingShipment"
          );
        case "Completed":
          return offer[0].Status === "Completed";
        case "Sent":
          return offer[0].BuyerId === userId;
        case "Countered":
          return offer[0].Status === "Countered";
        case "Rejected":
          return offer[0].Status === "Rejected";
        default:
          return false;
      }
    });
  };
  

  const [showMoreBuyer, setShowMoreBuyer] = useState(false);
  const [showMoreSeller, setShowMoreSeller] = useState(false);

  const toggleBuyerMenu = () => setShowMoreBuyer(!showMoreBuyer);
  const toggleSellerMenu = () => setShowMoreSeller(!showMoreSeller);

  const menuOptions = {
    buyer: {
      important: [
        { label: t("Waiting for Response"), value: "Waiting" },
        { label: t("PayNow"), value: "PayNow" },
        { label: t("Awaiting Shipment"), value: "WaitingShipment" },
        { label: t("ComingYourWay"), value: "ComingYourWay" },
      ],
      extra: [
        { label: t("Accepted"), value: "Accepted" },
        { label: t("Offers Sent"), value: "Sent" },
        { label: t("Countered Offers"), value: "Countered" },
        { label: t("Rejected Offers"), value: "Rejected" },
        { label: t("Completed"), value: "Completed" },
      ],
    },
    seller: {
      important: [
        { label: t("Waiting for Response"), value: "Waiting" },
        { label: t("ShipNow"), value: "ShipNow" },
        { label: t("Awaiting Payment"), value: "WaitingPayment" },
      ],
      extra: [
        { label: t("Shipped"), value: "Shipped" },
        { label: t("Accepted"), value: "Accepted" },
        { label: t("Countered Offers"), value: "Countered" },
        { label: t("Rejected Offers"), value: "Rejected" },
        { label: t("Offers Received"), value: "OffersReceived" },
        { label: t("Offers Sent"), value: "Sent" },
        { label: t("Completed"), value: "Completed" },
      ],
    },
  };
  const filteredBuyerOffers = useMemo(() => {
    if (!transactions || transactions.length === 0) {
      console.log("Skipped filteredBuyerOffers, empty transactions");
      return { important: [], extra: [] };
    }
  
    console.log("Recomputing filteredBuyerOffers", transactions);
  
    return {
      important: menuOptions.buyer.important.map((option) => ({
        ...option,
        count: filterSaleOffers(option.value, "buyer").length,
      })),
      extra: menuOptions.buyer.extra.map((option) => ({
        ...option,
        count: filterSaleOffers(option.value, "buyer").length,
      })),
    };
  }, [transactions, userId, saleOffers]); // 🟢 Added saleOffers

  const filteredSellerOffers = useMemo(() => {
    if (!transactions || transactions.length === 0) {
      return { important: [], extra: [] };
    }
  
    return {
      important: menuOptions.seller.important.map((option) => ({
        ...option,
        count: filterSaleOffers(option.value, "seller").length,
      })),
      extra: menuOptions.seller.extra.map((option) => ({
        ...option,
        count: filterSaleOffers(option.value, "seller").length,
      })),
    };
  }, [transactions, userId, saleOffers]); // 🟢 Added saleOffers




  console.log("📦 filteredBuyerOffers", filteredBuyerOffers);
 console.log("🧩 transactions", transactions);
  const getStatusIndicator = (option, count) => {
   
    if (count === 0) return null; // No badge if count is zero

    switch (option.value) {
      case "Waiting":
      case "Counter":
        return <span className="badge urgent">🔴</span>; // Hourglass for payments
      case "PayNow":
      case "WaitingPayment":
        return <span className="badge urgent">⏳💲</span>; // Hourglass for payments

      case "WaitingShipment":
        return <span className="badge medium">⏳📦</span>; // Shipping for shipment
      case "ShipNow":
        return <span className="badge medium">⏳🚚</span>; // Shipping for shipment
      case "Countered":
        return <span className="badge low">🔄 </span>; // Counter offer
      default:
        return <span className="badge normal"></span>; // Default gray badge
    }
  };

  return (
    <div className="view-sale-offers-global">
      {/* <button onClick={fetchSoldOrOffer}>Refresh</button> */}
      

      <div className="view-sale-offers">
        <div className="menu-container">
          {/* Buyer Menu */}
          <div className="menu buyer-menu">
            <h3 className="menu-title">{t("Buyer Menu")}</h3>
            <div className="menu-list">
              {filteredBuyerOffers.important.map((option) => (
                <div
                  key={option.value}
                  className={`menu-item ${
                    selectedBuyerOption === option.value ? "active" : ""
                  }`}
                  onClick={() => {
                    handleBuyerOptionChange(option.value)
            
                    const params = new URLSearchParams(location.search);
                    params.set('preselected', option.value);  // Update preselected in the URL
                    params.set('sellView', 'soldOrOffer');  // Ensure sellView stays in the URL
                    
                    const newUrl = `${location.pathname}?${params.toString()}`;
                    window.history.replaceState(null, '', newUrl);}
                  }
                >
                  {option.label}({option.count})
                  {getStatusIndicator(option, option.count)}
                </div>
              ))}

              {/* Expand/Collapse Button */}
              <button className="btn-baseBlue" onClick={toggleBuyerMenu}>
                {showMoreBuyer ? t("Show Less") : t("Show More")}
              </button>

              {/* Extra Options (Only Shown If Expanded) */}
              {showMoreBuyer &&
                filteredBuyerOffers.extra.map((option) => (
                  <div
                    key={option.value}
                    className={`menu-item ${
                      selectedBuyerOption === option.value ? "active" : ""
                    }`}
                    onClick={() => {handleBuyerOptionChange(option.value)
                      
                  const params = new URLSearchParams(location.search);
                  params.set('preselected', option.value);  // Update preselected in the URL
                  params.set('sellView', 'soldOrOffer');  // Ensure sellView stays in the URL
                  
                  const newUrl = `${location.pathname}?${params.toString()}`;
                  window.history.replaceState(null, '', newUrl);
                    }}
                  >
                    {option.label}({option.count})
                  {getStatusIndicator(option, option.count)}
                  </div>
                ))}
            </div>
          </div>

          {/* Seller Menu */}
          <div className="menu seller-menu">
            <h3 className="menu-title">{t("Seller Menu")}</h3>
            <div className="menu-list">
              {filteredSellerOffers.important.map((option) => (
                <div
                  key={option.value}
                  className={`menu-item ${
                    selectedSellerOption === option.value ? "active" : ""
                  }`}
                  onClick={() => {handleSellerOptionChange(option.value)
                
                  const params = new URLSearchParams(location.search);
                  params.set('preselected', option.value);  // Update preselected in the URL
                  params.set('sellView', 'soldOrOffer');  // Ensure sellView stays in the URL
                  
                  const newUrl = `${location.pathname}?${params.toString()}`;
                  window.history.replaceState(null, '', newUrl);
                }}
                >
                  {option.label}({option.count})
                  {getStatusIndicator(option, option.count)}
                </div>
              ))}

              {/* Expand/Collapse Button */}
              <button className="btn-baseBlue" onClick={toggleSellerMenu}>
                {showMoreSeller ? t("Show Less") : t("Show More")}
              </button>

              {/* Extra Options (Only Shown If Expanded) */}
              {showMoreSeller &&
                filteredSellerOffers.extra.map((option) => (
                  <div
                    key={option.value}
                    className={`menu-item ${
                      selectedSellerOption === option.value ? "active" : ""
                    }`}
                    onClick={() => {handleSellerOptionChange(option.value)
                      
                  const params = new URLSearchParams(location.search);
                  params.set('preselected', option.value);  // Update preselected in the URL
                  params.set('sellView', 'soldOrOffer');  // Ensure sellView stays in the URL
                  
                  const newUrl = `${location.pathname}?${params.toString()}`;
                  window.history.replaceState(null, '', newUrl);
                    }}
                  >
                    {option.label}({option.count})
                  {getStatusIndicator(option, option.count)}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>

      {/* Render GridSoldOrOffer only for the selected menu */}
      <div className="offers-container">
        {selectedBuyerOption && (
          <GridSoldOrOffer
            transactions={filterSaleOffers(selectedBuyerOption, "buyer")}
            setTransactions={setTransactions}
            Status={selectedBuyerOption}
            userId={userId}
            liveCsrfToken={liveCsrfToken}
            fetchSoldOrOffer={fetchSoldOrOffer}
            initialOpenTxId={initialOpenTxId}
          />
        )}
        {selectedSellerOption && (
          <GridSoldOrOffer
            transactions={filterSaleOffers(selectedSellerOption, "seller")}
            setTransactions={setTransactions}
            Status={selectedSellerOption}
            userId={userId}
            liveCsrfToken={liveCsrfToken}
            fetchSoldOrOffer={fetchSoldOrOffer}
            initialOpenTxId={initialOpenTxId}
          />
        )}
      </div>
    </div>
  );
};

export default ViewSaleOffer;
